<section
  #modalContent
  class="border-border background-background"
  [class.inverted]="inverted"
  [class.show-border]="showBorder"
>
  <div
    class="drop-message click"
    *ngIf="addTag && searchString?.length > 0"
    (click)="addNewItem()"
  >
    <ng-container *ngIf="(maxSelectedItems && maxSelectedItems > value.length) || !maxSelectedItems; else maxSelectTemp">
      <p *ngIf="showAddTagOnlyIfNoResults ? displayItems.length === 0 : true">
        <span>Add item </span>"{{ searchFieldValue }}"
      </p>
    </ng-container>
  </div>

  <div class="drop-message" *ngIf="(!items || items.length === 0) && searchString?.length === 0">
    <p>{{ noItemsText }}</p>
  </div>

  <div class="drop-message" *ngIf="displayItems?.length === 0 && !addTag && searchString?.length > 0">
    <p>No items found</p>
</div>
  <ion-list lines="full" mode="ios">
    <div #listContent class="list-wrapper" [style.max-height]="maxListHeight" [style.min-width]="minWidth">
      <ion-item
        [class.readonly]="disabled"
        id="display-item-{{item[bindValue]}}"
        *ngFor="let item of displayItems"
        (click)="selectSingleItem(item[bindValue])"
        class="ion-focusable ion-activatable"
      >
        <frontend-tooltip
          parentId="display-item-{{item[bindValue]}}"
          *ngIf="optionWrapper.offsetWidth < optionBody.offsetWidth"
          [text]="itemsIdToLabelMap[item[bindValue]]"
        ></frontend-tooltip>

        <ion-checkbox
          *ngIf="multiple"
          justify="start"
          mode="md"
          [checked]="itemsIdToStateMap[item[bindValue]]"
          [disabled]="false"
          (ionChange)="checkboxChange(item[bindValue], $event.detail)"
        ></ion-checkbox>

        <div *ngIf="!multiple" class="hidden-checkbox"></div>

        <div
          class="option-wrapper"
          #optionWrapper
          [style.min-height.px]="optionBody.offsetHeight"
        >
          <div #optionBody class="new-dropdown-option-text" [innerHTML]="itemsIdToLabelMap[item[bindValue]]"></div>

          <tr-icon
            *ngIf="!multiple && itemsIdToStateMap[item[bindValue]]"
            [icon]="icon.check"
            [size]="size.regular"
          ></tr-icon>
        </div>

        <div class="option-divider background-border"></div>
      </ion-item>
    </div>
  </ion-list>
</section>

<ng-template #maxSelectTemp>
  <p><span>Maximum amount of items already selected. <b>Clear</b></span></p>
</ng-template>
